<script lang="ts">
	import ShellLayout from "./ShellLayout.svelte";
	import Presentations from "./Presentations.svelte";
</script>

<ShellLayout><Presentations /></ShellLayout>
